export default "__VITE_ASSET__DRnD4rY3__"